export default __webpack_public_path__ + "static/13_37-2ec840652e3df7ee9cf70125da57786b.png";